$(() => {
  /**
   * Manage a registrant form
   *
   * https://raceroster.com
   */
  $.RegistrantPlugin = function registrantPlugin(options) {
    const defaults = {
      registrantUuid: null,
      registrantIndex: 1,
      isKioskRegistration: false,
      isSeriesRegistration: false,
      subEventId: null,
      subEventName: null,
      registrationUrl: null,
      entryUrl: null,
      eventUrl: null,
      subEventsUrl: null,
      subEventSelectionUrl: null,
      membershipValidationUrl: null,
      validationUrl: null,
      startGroupValidationUrl: null,
      eventCountry: null,
      currency: null,
      locale: null,
      i18n: {},
      usat: {},
      usatBatch: {},
      hasCustomSubEventRequiredFields: false,
      subEventRequiredFields: {},
      eventRequiredFields: {},
      accountPersonalInformation: null,
      suggestedRegistrantsPersonalInformation: null,
      registrantPersonalInformation: null,
      registrantsPersonalInformation: null,
      ageMinimumDefault: null,
      ageMinimums: {},
      subEventAgeLimits: null,
      language: 'en',
      languageRegion: 'US',
      autocompleteService: 'google',
      newFundraisingFlow: false,
      regFlowOtpLogin: false,
      isWebView: false,
      separateFeatureSteps: false,
      selectOnlySubEvent: true,
      ageModalRedirectRoute: null,
      callbacks: {
        subEventSelected: () => {},
        registrantSaved: () => {},
      },
    };

    const plugin = this;

    let settings = {};
    let i18n = {};
    const html = {
      spinner: '<span class="fa fa-3x fa-spinner fa-pulse" aria-hidden="true"></span>',
    };
    let registrantFeaturesRequest = null;
    let pendingRegistrantFeatureLoad = null;
    let guestEmailAddress = null;
    // Server-authoritative "add another registrant" permission, refreshed on every sub-event
    // selection because the chosen sub-event can change the registration type (a ballot sub-event
    // switches the registration to ballot, which is single-registrant only). Null until the first
    // selection response, at which point the server-rendered state on the button is used instead.
    let canAddRegistrant = null;

    const $pluginContainer = $('.js-registrant');
    const $snackBar = $('[data-js-snack-bar]');

    // Components of a registrant
    const components = {
      // no plugin for registrant management
      registrantManagement: {
        form: $pluginContainer.find('.js-switch-registrant-form'),
      },
      accessCodes: {
        form: $pluginContainer.find('.js-access-codes'),
        plugin: null,
      },
      personalInformation: {
        form: $pluginContainer.find('.js-registrant-personal-information-form'),
        plugin: null,
      },
      subEventValidation: {
        form: $pluginContainer.find('.js-registrant-sub-event-validation-form'),
        plugin: null,
        pluginName: 'subEventValidationPlugin',
      },
      discountValidation: {
        form: $pluginContainer.find('.js-registrant-discount-validation-form'),
        plugin: null,
        pluginName: 'discountValidationPlugin',
      },
      startGroups: {
        form: $pluginContainer.find('.js-registrant-start-groups-form'),
        plugin: null,
        pluginName: 'startGroupsPlugin',
      },
      estimatedFinishTime: {
        form: $pluginContainer.find('.js-registrant-estimated-finish-time-form'),
        plugin: null,
        pluginName: 'estimatedFinishTimePlugin',
      },
      registrationQuestions: {
        form: $pluginContainer.find('.js-registrant-questions-form'),
        plugin: null,
        pluginName: 'questionsPlugin',
      },
      memberships: {
        form: $pluginContainer.find('.js-registrant-memberships-form'),
        plugin: null,
      },
      teams: {
        form: $pluginContainer.find('.js-registrant-teams-form'),
        plugin: null,
      },
      products: {
        form: $pluginContainer.find('.js-registrant-products-form'),
        plugin: null,
      },
      usat: {
        form: $pluginContainer.find('.js-registrant-usat-form'),
        plugin: null,
      },
      usatBatch: {
        form: $pluginContainer.find('.js-registrant-usat-batch-form'),
        plugin: null,
      },
      promoCodes: {
        form: $pluginContainer.find('.js-registrant-promo-codes-form'),
        plugin: null,
      },
      subEvents: {
        form: $pluginContainer.find('.js-registrant-sub-events-form'),
        plugin: null,
        pluginName: 'subEventsPlugin',
      },
      fundraisingSettings: {
        form: $pluginContainer.find('.js-registrant-fundraising-settings-form'),
        plugin: null,
        pluginName: 'fundraisingSettingsPlugin',
      },
    };

    /**
     * Get the requested plugin
     * @param {string} name
     */
    plugin.getPlugin = (name) => components[name].plugin || null;

    /**
     * Parse the error message from response
     *
     * @param {object} response
     * @returns {string}
     */
    plugin.parseErrorMessage = (response) => {
      if (typeof response.responseJSON !== 'object') {
        return response.responseText;
      }

      // not sure if it's possible for the backend to return something that doesn't have the
      // errors property, but just in case, we'll show a generic "try again"
      if (!response.responseJSON.errors) {
        return settings.i18n.genericError;
      }

      const { errors } = response.responseJSON;
      let errorMessage = '';

      if (Object.keys(errors).length > 0) {
        if (Object.keys(errors).length > 1) {
          $.each(errors, (key, error) => {
            errorMessage += `• ${error}\n`;
          });
        } else {
          [errorMessage] = Object.values(errors);
        }

        return errorMessage;
      }

      return errorMessage;
    };

    /**
     * Don't let em submit again
     */
    plugin.disableSubmitButtons = ($button) => {
      $pluginContainer.find('button[type="submit"]').prop('disabled', true);

      // Display the spinner for the button that was clicked
      if (typeof $button !== 'undefined') {
        $button.find('.js-spinner').removeClass('hidden');
      }
    };

    /**
     * Okay fine let em submit again
     */
    plugin.reEnableSubmitButtons = () => {
      $pluginContainer.find('button[type="submit"]').not('[data-disabled="true"]').prop('disabled', false);
      $pluginContainer.find('.js-spinner').addClass('hidden');
    };

    /**
     * For when the server is a little grumpy
     * @param content
     */
    const addDangerSnack = (content) => {
      if (!content) {
        return;
      }

      $snackBar.snackBar('add', {
        type: 'danger',
        icon: 'exclamation-circle',
        content,
      });
    };

    /**
     * Takes an error message, splits it up and removes the weird bullety stuff, then sends it along to be made
     * into a delicious danger snack.
     * @param error
     */
    const alertErrorMessage = (error) => {
      if (!error) {
        return;
      }

      error
        .split(/\r?\n/)
        .forEach((singleError) => {
          if (!singleError) {
            return;
          }

          addDangerSnack(singleError.replace('•', '').trim());
        });
    };

    /**
     * Serialize a component
     * @param {object} component
     * @returns {string}
     */
    const serializeComponent = (component) => {
      if (component.plugin?.[component.pluginName]?.getMethods?.serialize) {
        return component.plugin[component.pluginName]('serialize');
      }

      if (component.plugin?.serialize) {
        return component.plugin.serialize();
      }

      return component.form.serialize();
    };

    /**
     * Loops through all the components' forms and builds a data string out of their form serializations to be used
     * in ajax requests
     * @returns {string}
     */
    const serializeComponents = () => {
      // not sure if `components` can ever be a falsey value, but just in case, we'll just
      // return an empty string
      if (!components) {
        return '';
      }

      return Object
        .values(components)
        .reduce((data, component) => {
          if (component.form.data('disabled')) {
            return data;
          }

          const serializedForm = serializeComponent(component);

          if (!serializedForm) {
            return data;
          }

          // Extract feature name for metrics key
          const $featureInput = component.form.find('input[name=feature]');
          const featureKey = $featureInput.length ? $featureInput.val() : component.form.attr('name');

          // if the plugin has metrics, attach em in json format
          const metrics = component.plugin?.getMetrics
            ? `${encodeURIComponent(`metrics[${featureKey}]`)}=${encodeURIComponent(JSON.stringify(component.plugin.getMetrics()))}&`
            : '';

          return `${data}${serializedForm}&${metrics}`;
        }, '');
    };

    /**
     * When an input with a pattern attribute is invalid, add an accessible help block
     * @param $field
     */
    const invalidPattern = ($field) => {
      const $container = $field.closest('.form-group');
      const $parent = $container.length ? $container : $field.parent();
      const $helpBlock = $parent.find('.help-block');
      const message = $field.attr('title') || '';

      if (message !== '') {
        if ($helpBlock.length) {
          $helpBlock.text(message);
        } else {
          $parent.append(`<p class="help-block" id="${$field.attr('id')}-error">${message}</p>`);
        }

        $field.attr('aria-describedby', `${$field.attr('id')}-error`);
      }

      // there's some silly float css causing the help block to look awful without the clearfix
      $parent.addClass('has-error clearfix');
    };

    /**
     * Show a validation message against a field
     * @param $field
     * @param message
     */
    plugin.showFieldError = ($field, message) => {
      $field.attr('title', message);
      invalidPattern($field);
    };

    /**
     * Remove a validation message previously shown against a field
     * @param $field
     */
    plugin.clearFieldError = ($field) => {
      const $container = $field.closest('.form-group');
      const $parent = $container.length ? $container : $field.parent();

      $parent.removeClass('has-error clearfix');
      $parent.find('.help-block[id$="-error"]').remove();
      $field.removeAttr('aria-describedby title');
    };

    /**
     * Phone format errors reuse the Twig title as the help-block copy. Keep that title so a later
     * invalid submit can show the message again (clearFieldError strips title for dynamic errors).
     */
    const clearPhoneFormatError = ($field) => {
      const $container = $field.closest('.form-group');
      const $parent = $container.length ? $container : $field.parent();

      $parent.removeClass('has-error clearfix');
      $parent.find('.help-block[id$="-error"]').remove();
      $field.removeAttr('aria-describedby');
    };

    const clearPhoneFormatErrorIfResolved = function clearPhoneFormatErrorIfResolved() {
      const phoneNumber = window.intlTelInput?.getInstance?.(this);

      if (!$(this).val() || phoneNumber?.isValidNumber()) {
        clearPhoneFormatError($(this));
      }
    };

    /**
     * Is the form valid?
     * @returns {boolean}
     * @private
     */
    const isFormValid = () => {
      let invalid = false;
      const $fundraisingForm = components.fundraisingSettings.form;

      // Set the goal's custom validity up front so the checks below report it like any other
      // invalid field
      if ($fundraisingForm.length && typeof $fundraisingForm.fundraisingSettingsPlugin === 'function') {
        $fundraisingForm.fundraisingSettingsPlugin('validateGoal');
      }

      // Validate each of the component forms
      $.each(components, (componentIndex, component) => {
        const $form = component.form;

        if ($form.length && !$form[0].checkValidity()) {
          $form
            .find('input:invalid, select:invalid, textarea:invalid')
            .not('.date-picker__form-control')
            .each((elementIndex, element) => {
              const $input = $(element);

              $input.parent().addClass('has-error');

              if ($input.is('[pattern]')) {
                invalidPattern($input);
              }

              // Focus on the first invalid field
              if ($input.is(':visible') && !invalid) {
                invalid = true;
                $input.focus();

                // Create and click a temporary button to trigger the HTML5 submit validation
                const tmpSubmit = document.createElement('button');
                $form[0].appendChild(tmpSubmit);
                tmpSubmit.click();
                $form[0].removeChild(tmpSubmit);
              }
            });
        }

        // Check the validity of the phone number fields
        $form.find('[data-format-phone-number]').each((key, element) => {
          const $element = $(element);
          const phoneNumber = window.intlTelInput.getInstance(element);

          // Only validate client side if visible and a value has been input by the user
          // (required validation is done by the browser itself)
          if ($element.is(':visible') && $element.val() && phoneNumber && !phoneNumber.isValidNumber()) {
            invalid = true;
            invalidPattern($element);
            $element.focus();
          } else if ($element.is(':visible')) {
            clearPhoneFormatError($element);
          }
        });

        $form.find('[data-has-option-selection-quantity-restrictions]').each((key, element) => {
          const $element = $(element);
          const minimum = parseInt($element.attr('data-minimum-option-selection') || 0, 10);
          const maximum = parseInt($element.attr('data-maximum-option-selection') || 0, 10);
          const $checkboxes = $element.find('[type="checkbox"]');
          const selectionQuantity = $checkboxes.filter(':checked').length;
          let quantityRestrictionSatisfied = true;

          if (minimum && selectionQuantity < minimum) {
            quantityRestrictionSatisfied = false;
          }

          if (maximum && selectionQuantity > maximum) {
            quantityRestrictionSatisfied = false;
          }

          if (!quantityRestrictionSatisfied) {
            invalid = true;
            $element.closest('.form-group').addClass('has-error');
            $checkboxes.first().trigger('focus');
          }
        });
      });

      // Prevent submitting if the form is not valid
      return !invalid;
    };

    /**
     * Save a registrant and redirect the user to the returned destination
     */
    plugin.saveRegistrant = function saveRegistrant(event, checkAge = true) {
      if (event) {
        event.preventDefault();
      }

      // Use browser validation first
      if (!isFormValid()) {
        return;
      }

      if (checkAge && !components.personalInformation.plugin.checkAge()) {
        $pluginContainer.find('.js-age-modal').data('actionButton', this).modal('show');
        return;
      }

      if (!components.personalInformation.plugin.checkSubEventCountry()) {
        return;
      }

      // We know which button was clicked in this case, so we're going to add a spinner to it
      plugin.disableSubmitButtons($(this));

      // serialize the data then tack on the button value
      const data = `${serializeComponents()}&action=${$(this).val()}`;

      $.ajax({
        url: $('#registration-form').attr('action'),
        type: 'post',
        data,
        dataType: 'json',
      })
        .done((response) => {
          settings.callbacks.registrantSaved();
          window.location.href = response.redirect;
        })
        .fail((response) => {
          alertErrorMessage(plugin.parseErrorMessage(response));
          plugin.reEnableSubmitButtons();
        });
    };

    /**
     * Submits the current registration's information and if it was good, switch to the request registrant
     * @param event
     */
    const switchRegistrant = function switchRegistrant(event) {
      const newRegistrantIndex = parseInt($(this).find('.js-switch-registrant-select').val(), 10);

      event.preventDefault();

      if (newRegistrantIndex === settings.registrantIndex || !isFormValid()) {
        return;
      }

      plugin.disableSubmitButtons();

      $.ajax({
        url: settings.switchRegistrantUrl,
        type: 'post',
        data: serializeComponents(),
        success: ({ redirect }) => {
          window.location.href = redirect;
        },
        error: (response) => alertErrorMessage(plugin.parseErrorMessage(response)),
        complete: plugin.reEnableSubmitButtons,
      });
    };

    /**
     * Cancel any active requests being made
     */
    const cancelActiveRequests = () => {
      if (registrantFeaturesRequest) {
        registrantFeaturesRequest.abort();
      }

      $.each(components, (index, component) => {
        if (!component.plugin) {
          return;
        }

        if (component.plugin instanceof jQuery) {
          component.plugin[component.pluginName]?.('cancelActiveRequests');
          return;
        }

        component.plugin.cancelActiveRequests?.();
      });
    };

    /**
     * Removes the current registrant from the registration
     */
    const removeRegistrant = () => {
      plugin.disableSubmitButtons();
      cancelActiveRequests();

      $.ajax({
        url: settings.removeRegistrantUrl,
        type: 'post',
        data: serializeComponents(),
        success: ({ redirect }) => {
          window.location.href = redirect;
        },
        error: (response) => alertErrorMessage(plugin.parseErrorMessage(response)),
        complete: plugin.reEnableSubmitButtons,
      });
    };

    /**
     * Toggle the visibility of the registrant spinner
     *
     * @param isVisible
     * @private
     */
    plugin.toggleRegistrantSpinner = (isVisible) => {
      const $registrantSpinner = $pluginContainer.find('.js-registrant-spinner');

      if (isVisible) {
        $registrantSpinner.html(html.spinner).fadeIn(200);
      } else {
        $registrantSpinner.fadeOut();
      }
    };

    /**
     * Toggle the visibility of registrant components
     *
     * @param isVisible
     * @private
     */
    const toggleComponents = (isVisible) => {
      $.each(components, (index, component) => {
        if (component.form.hasClass('js-registrant-feature-form')) {
          component.plugin.toggleVisibility?.(isVisible);
        }
      });
    };

    /**
     * Clear the content of the previous sub-event features
     *
     * @private
     */
    const clearRegistrationComponents = () => {
      $.each(components, (index, component) => {
        if (component.plugin?.[component.pluginName]?.methods?.clear) {
          component.plugin[component.pluginName]('clear');
        } else if (component.form.hasClass('js-registrant-feature-form')) {
          component.plugin.clear?.();
        }
      });
    };

    /**
     * Display error message and redirect user if 406 error response
     *
     * @param response
     * @private
     */
    plugin.handleErrorResponse = (response) => {
      // Display an error message alert if a message is returned
      if (response.responseText) {
        alertErrorMessage(response.responseText);
      }

      // The registration is invalid, redirect the user out of registration
      if (response.status === 406) {
        window.location.replace(settings.eventUrl);
      }
    };

    /**
     * Shows the submit buttons if they should be shown
     * @param $subEvent
     * @private
     */
    const showSubmitButtons = ($subEvent) => {
      const $addRegistrant = $pluginContainer.find('.js-add-registrant');
      const allowedBySubEvent = $subEvent.is('select')
        ? $subEvent.find(':selected').data('allow-add')
        : $subEvent.data('allow-add');
      const allowedByRegistration = canAddRegistrant === null
        ? $addRegistrant.data('can-add-registrant') !== false
        : canAddRegistrant;
      const hasAddRegistrantButton = Boolean(allowedBySubEvent) && allowedByRegistration;

      $addRegistrant
        .data('disabled', !hasAddRegistrantButton)
        .prop('disabled', !hasAddRegistrantButton)
        .toggleClass('hidden', !hasAddRegistrantButton);

      // The reskin wraps the button in a padded container that would otherwise leave a stray gap.
      // No-op on the legacy layout, which has no wrapper.
      $addRegistrant
        .closest('.js-add-registrant-container')
        .toggleClass('hidden', !hasAddRegistrantButton);

      $pluginContainer
        .find('.js-continue,.js-add-team-member')
        .not('[data-disabled="true"]')
        .prop('disabled', false)
        .removeClass('hidden');
      $pluginContainer
        .find('.js-registrant-terms-form')
        .removeClass('hidden');
    };

    /**
     * Hides the submit buttons
     * @private
     */
    const hideSubmitButtons = () => {
      $pluginContainer.find('.js-add-registrant').addClass('hidden');
      $pluginContainer.find('.js-continue,.js-add-team-member').addClass('hidden');
      $pluginContainer.find('.js-registrant-terms-form').addClass('hidden');
    };

    /**
     * Initialize the plugin content. Logic included to make sure that if the plugin is jQuery,
     * the jQuery method is called. Otherwise, call the older class-style method.
     * @param featureIdentifier
     */
    plugin.initializeFeatureContent = (featureIdentifier) => {
      if (!settings.subEventId) {
        return;
      }

      const component = components[featureIdentifier];

      if (!component) {
        return;
      }

      if (component.plugin instanceof jQuery) {
        component.plugin[component.pluginName]?.('initializeContent');
        return;
      }

      components[featureIdentifier].plugin.initializeContent(settings.subEventId);
    };

    const prefillGuestEmail = () => {
      if (!guestEmailAddress) {
        return;
      }

      const $emailFields = components.personalInformation.form.find('.js-email, .js-email-confirm');
      if (!$emailFields.length) {
        return;
      }

      $emailFields.val(guestEmailAddress).trigger('change');
      guestEmailAddress = null;
    };

    plugin.continueRegistrationAsGuest = (emailAddress) => {
      if (!pendingRegistrantFeatureLoad) {
        return false;
      }

      const featureLoad = pendingRegistrantFeatureLoad;
      pendingRegistrantFeatureLoad = null;
      guestEmailAddress = emailAddress;
      settings.regFlowOtpLogin = false;

      plugin.toggleRegistrantSpinner(true);
      plugin.loadRegistrantFeatures(featureLoad.$subEvent, featureLoad.subEventId);
      return true;
    };

    /**
     * Get the features for the registrant
     *
     * @private
     */
    plugin.loadRegistrantFeatures = ($subEvent, subEventId) => {
      // Show Verify your email once a sub-event is selected (widget while anonymous,
      // disabled verified-email field after authentication).
      $pluginContainer.find('.js-otp-widget-section').removeClass('hidden');

      // Anonymous OTP: wait for verification. After reload the user is authenticated,
      // this flag is off, and pre-selected sub-event loading continues here as usual.
      if (settings.regFlowOtpLogin) {
        pendingRegistrantFeatureLoad = { $subEvent, subEventId };
        plugin.toggleRegistrantSpinner(false);

        if (typeof window.mountOtpWidget === 'function') {
          window.mountOtpWidget();
        }

        return;
      }

      pendingRegistrantFeatureLoad = null;

      // If we're rendering the features as separate steps, we will instead simply submit
      if (settings.separateFeatureSteps) {
        plugin.toggleRegistrantSpinner(true);
        plugin.saveRegistrant.call($pluginContainer.find('.js-continue'), null, false);
        return;
      }

      if (registrantFeaturesRequest) {
        registrantFeaturesRequest.abort();
      }

      // Display the personal information component while other components are loading
      components.personalInformation.plugin.toggleVisibility(true);

      registrantFeaturesRequest = $.ajax({
        url: `${settings.registrationUrl}/registrant/${settings.registrantIndex}/features`,
        type: 'GET',
      }).always(() => {
        registrantFeaturesRequest = null;
      }).done(({ data }) => {
        if (typeof data.registrant !== 'undefined') {
          components.personalInformation.plugin.displayContent(data.registrant, subEventId);
          prefillGuestEmail();
          components.subEventValidation.form.subEventValidationPlugin('shouldUsePersonalInformationCallbacks');
          components.discountValidation.form.discountValidationPlugin('shouldUsePersonalInformationCallbacks');
        }

        if (typeof data['sub-event-validation'] !== 'undefined') {
          components.subEventValidation.form.subEventValidationPlugin('setup', data['sub-event-validation']);
        }

        if (typeof data['discount-validation'] !== 'undefined') {
          components.discountValidation.form.discountValidationPlugin('setup', data['discount-validation']);
        }

        if (typeof data['start-groups'] !== 'undefined') {
          components.startGroups.form.startGroupsPlugin('setup', data['start-groups']);
        }

        if (typeof data['estimated-finish-time'] !== 'undefined') {
          components.estimatedFinishTime.form.estimatedFinishTimePlugin('setup', data['estimated-finish-time']);
        }

        if (typeof data.teams !== 'undefined') {
          components.teams.plugin.displayContent(data.teams);
        }

        if (typeof data.products !== 'undefined') {
          components.products.plugin.displayContent(data.products);
        }

        if (typeof data.questions !== 'undefined') {
          components.registrationQuestions.plugin.displayContent(data.questions);
        }

        if (typeof data.memberships !== 'undefined') {
          components.memberships.plugin.displayContent(data.memberships);
        }

        if (typeof data.usat !== 'undefined') {
          components.usat.plugin.displayContent(data.usat);
        }

        if (typeof data['usat-batch'] !== 'undefined') {
          components.usatBatch.plugin.displayContent(data['usat-batch']);
        }

        if (typeof data['promo-codes'] !== 'undefined') {
          components.promoCodes.plugin.displayContent(data['promo-codes']);
        }

        if (typeof data['fundraising-settings'] !== 'undefined') {
          components.fundraisingSettings.form.fundraisingSettingsPlugin('setup', data['fundraising-settings']);
        }

        plugin.toggleRegistrantSpinner(false);

        // Display the components
        toggleComponents(true);

        showSubmitButtons($subEvent);
      }).fail((response) => {
        plugin.toggleRegistrantSpinner(false);
        plugin.handleErrorResponse(response);
      });
    };

    /**
     * Disable and toggle visibility of components
     */
    plugin.unloadRegistrationComponents = (showSpinner = true) => {
      components.personalInformation.plugin.toggleVisibility(false);
      plugin.toggleRegistrantSpinner(showSpinner);
      toggleComponents(false);
      clearRegistrationComponents();
      hideSubmitButtons();
    };

    /**
     * Don't let hitting enter submit any forms
     * @param event
     */
    const preventEnterSubmission = (event) => {
      if ($(event.target).closest('.js-otp-guest-fallback').length) {
        return;
      }

      const code = event.keyCode || event.which;

      if (code === 13 && event.target.nodeName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };

    /**
     * Remove error formatting if valid
     */
    const removeErrorFormatting = function removeErrorFormatting() {
      const $this = $(this);

      if ($this.is(':valid')) {
        $this.parent().removeClass('has-error');
      }
    };

    /**
     * We originally thought the user didn't meet the age requirements, but then they indicated they are registering
     * someone else. Switch the myself/someone else radio to someone else then submit the form using the button
     * they clicked before the modal open
     * @param event
     */
    const saveSomeoneElse = (event) => {
      const $ageModal = $pluginContainer.find('.js-age-modal');

      $pluginContainer.find('.js-register-someone-else').prop('checked', true);
      $ageModal.modal('hide');

      plugin.saveRegistrant.call($ageModal.data('actionButton'), event, false);
    };

    /**
     * User doesn't meet age requirements so send em to the error page
     */
    const redirectToProcessingError = () => {
      window.location.href = settings.ageModalRedirectRoute;
    };

    /**
     * Initialize the listeners for the registrant form
     *
     * @private
     */
    const initializeListeners = () => {
      $pluginContainer.on('submit', '.js-switch-registrant-form', switchRegistrant);
      $pluginContainer.on('click', '.js-remove-registrant', removeRegistrant);
      $pluginContainer.on('keyup keypress', preventEnterSubmission);
      $pluginContainer.on('blur', ':input', removeErrorFormatting);
      $pluginContainer.on('input countrychange', '[data-format-phone-number]', clearPhoneFormatErrorIfResolved);
      $pluginContainer.on('click', '.js-registration-form :submit', plugin.saveRegistrant);
      $pluginContainer.on('click', '.js-age-modal-someone-else', saveSomeoneElse);
      $pluginContainer.on('click', '.js-age-modal-myself', redirectToProcessingError);
    };

    /**
     * Initialize plugin
     * Merge default settings with those passed in
     */
    const initialize = () => {
      settings = $.extend({}, defaults, options);

      ({ i18n } = settings);

      // create instance of registration questions plugin
      components.registrationQuestions.plugin = components.registrationQuestions.form
        .registrationQuestionsPlugin({
          registrationPlugin: plugin,
          i18n: settings.i18n,
          eventCountry: settings.eventCountry,
          registrantIndex: settings.registrantIndex,
          registrantPersonalInformation: settings.registrantPersonalInformation,
          callbacks: {
            getProvidedFor: () => components.personalInformation.plugin?.getProvidedFor(),
            getSelectedCountry: () => components.personalInformation.plugin?.getSelectedCountry(),
          },
        });

      // create instance of personal information plugin
      components.personalInformation.plugin = components.personalInformation.form.personalInformationPlugin({
        registrationPlugin: plugin,
        eventCountry: settings.eventCountry,
        registrationUrl: settings.registrationUrl,
        registrantIndex: settings.registrantIndex,
        eventRequiredFields: settings.eventRequiredFields,
        subEventRequiredFields: settings.subEventRequiredFields,
        hasCustomSubEventRequiredFields: settings.hasCustomSubEventRequiredFields,
        i18n: settings.i18n,
        accountPersonalInformation: settings.accountPersonalInformation,
        suggestedRegistrantsPersonalInformation: settings.suggestedRegistrantsPersonalInformation,
        registrantPersonalInformation: settings.registrantPersonalInformation,
        registrantsPersonalInformation: settings.registrantsPersonalInformation,
        ageMinimumDefault: settings.ageMinimumDefault,
        ageMinimums: settings.ageMinimums,
        subEventAgeLimits: settings.subEventAgeLimits,
        language: settings.language,
        languageRegion: settings.languageRegion,
        autocompleteService: settings.autocompleteService,
        registrationQuestionsPlugin: components.registrationQuestions.plugin,
        callbacks: {
          onGivenNameChange: () => {
            components.subEventValidation.form.subEventValidationPlugin('update');
            components.discountValidation.form.discountValidationPlugin('update');
            components.startGroups.form.startGroupsPlugin('update');
            components.usatBatch.plugin.methods.registrantChanged();
          },
          onFamilyNameChange: () => {
            components.subEventValidation.form.subEventValidationPlugin('update');
            components.discountValidation.form.discountValidationPlugin('update');
            components.startGroups.form.startGroupsPlugin('update');
            components.usatBatch.plugin.methods.registrantChanged();
          },
          onDateOfBirthChange: () => {
            components.subEventValidation.form.subEventValidationPlugin('update');
            components.discountValidation.form.discountValidationPlugin('update');
            components.startGroups.form.startGroupsPlugin('update');
            components.usatBatch.plugin.methods.registrantChanged();
          },
          onProvidedForChange: () => {
            components.usatBatch.plugin.methods.registrantChanged();
          },
          onSuggestedRegistrantChange: () => {
            components.usatBatch.plugin.methods.registrantChanged();
          },
        },
      });

      // create instance of sub-event validation plugin
      components.subEventValidation.plugin = components.subEventValidation.form.subEventValidationPlugin({
        registrationPlugin: plugin,
        registrationUrl: settings.registrationUrl,
        registrantPersonalInformation: settings.registrantPersonalInformation,
        isKioskRegistration: settings.isKioskRegistration,
        isSeriesRegistration: settings.isSeriesRegistration,
        subEventName: settings.subEventName,
        i18n: settings.i18n,
        routes: {
          validation: settings.validationUrl,
        },
        callbacks: {
          getGivenName: () => components.personalInformation.plugin.getGivenName(),
          getFamilyName: () => components.personalInformation.plugin.getFamilyName(),
          getDateOfBirth: () => components.personalInformation.plugin.getDateOfBirth(),
          getSubEvent: () => components.subEvents.plugin.subEventsPlugin('getSelectedSubEventName'),
        },
      });

      // create instance of discount validation plugin
      components.discountValidation.plugin = components.discountValidation.form.discountValidationPlugin({
        registrationPlugin: plugin,
        registrationUrl: settings.registrationUrl,
        registrantUuid: settings.registrantUuid,
        registrantPersonalInformation: settings.registrantPersonalInformation,
        isKioskRegistration: settings.isKioskRegistration,
        isSeriesRegistration: settings.isSeriesRegistration,
        eventId: settings.eventId,
        locale: settings.locale,
        currency: settings.currency,
        i18n: settings.i18n,
        routes: {
          validation: settings.validationUrl,
        },
        callbacks: {
          getGivenName: () => components.personalInformation.plugin.getGivenName(),
          getFamilyName: () => components.personalInformation.plugin.getFamilyName(),
          getDateOfBirth: () => components.personalInformation.plugin.getDateOfBirth(),
        },
      });

      // create instance of start groups plugin
      components.startGroups.plugin = components.startGroups.form.startGroupsPlugin({
        registrationPlugin: plugin,
        registrationUrl: settings.registrationUrl,
        i18n: settings.i18n,
        registrantPersonalInformation: settings.registrantPersonalInformation,
        registrantIndex: settings.registrantIndex,
        registrantUuid: settings.registrantUuid,
        routes: {
          validation: settings.startGroupValidationUrl,
        },
        callbacks: {
          getGivenName: () => components.personalInformation.plugin.getGivenName(),
          getFamilyName: () => components.personalInformation.plugin.getFamilyName(),
          getDateOfBirth: () => components.personalInformation.plugin.getDateOfBirth(),
        },
      });

      // create instance of estimated finish time plugin
      components.estimatedFinishTime.plugin = components.estimatedFinishTime.form.estimatedFinishTimePlugin({
        registrationPlugin: plugin,
      });

      // create instance of teams plugin
      components.teams.plugin = components.teams.form.teamsPlugin({
        registrationPlugin: plugin,
        registrationUrl: settings.registrationUrl,
        registrantIndex: settings.registrantIndex,
        registrantsPersonalInformation: settings.registrantsPersonalInformation,
        newFundraisingFlow: settings.newFundraisingFlow,
        i18n: {
          ...i18n.teamPhrases,
          loading: i18n.loading,
          noResultsFound: i18n.noResultsFound,
          searchByOrganizationName: i18n.searchByOrganizationName,
        },
        eventCountry: settings.eventCountry,
      });

      // create instance of products plugin
      components.products.plugin = components.products.form.productsPlugin({
        registrationPlugin: plugin,
        registrationUrl: settings.registrationUrl,
        i18n: settings.i18n,
      });

      // create instance of memberships plugin
      components.memberships.plugin = components.memberships.form.membershipsPlugin({
        registrationPlugin: plugin,
        personalInformation: components.personalInformation,
        registrationUrl: settings.registrationUrl,
        registrantIndex: settings.registrantIndex,
        membershipValidationUrl: settings.membershipValidationUrl,
        i18n: settings.i18n,
      });

      // create instance of USAT plugin
      components.usat.plugin = components.usat.form.usatPlugin({
        registrationPlugin: plugin,
        personalInformation: components.personalInformation,
        registrantPersonalInformation: settings.registrantPersonalInformation,
        registrationUrl: settings.registrationUrl,
        i18n: settings.i18n,
        usat: settings.usat,
      });

      // create instance of USAT plugin
      components.usatBatch.plugin = components.usatBatch.form.usatBatchPlugin({
        registrationPlugin: plugin,
        personalInformation: components.personalInformation,
        registrantPersonalInformation: settings.registrantPersonalInformation,
        registrationUrl: settings.registrationUrl,
        i18n: settings.i18n,
        usat: settings.usatBatch,
      });

      // create instance of promo codes plugin
      components.promoCodes.plugin = components.promoCodes.form.promoCodesPlugin({
        registrationPlugin: plugin,
        registrationUrl: settings.registrationUrl,
        i18n: settings.i18n,
      });

      // create instance of fundraising settings plugin
      components.fundraisingSettings.plugin = components.fundraisingSettings.form.fundraisingSettingsPlugin({
        registrationPlugin: plugin,
        registrationUrl: settings.registrationUrl,
        i18n: settings.i18n,
      });

      // create instance of sub-events plugin
      components.subEvents.plugin = components.subEvents.form.subEventsPlugin({
        selectOnlySubEvent: settings.selectOnlySubEvent,
        routes: {
          subEvents: settings.subEventsUrl,
          subEventSelection: settings.subEventSelectionUrl,
        },
        callbacks: {
          subEventSelected: (
            $element,
            data,
            $subEvent,
            subEventId,
            subEventName,
            subEventPrice,
            response
          ) => {
            if (typeof response?.canAddRegistrant === 'boolean') {
              canAddRegistrant = response.canAddRegistrant;
            }

            settings.callbacks.subEventSelected({
              subEventId,
              subEventName,
              subEventPrice,
            });
          },
          toggleRegistrantSpinner: ($element, data, showSpinner) => {
            plugin.toggleRegistrantSpinner(showSpinner);
          },
          loadRegistrantFeatures: ($element, data, $subEvent, subEventId) => {
            plugin.loadRegistrantFeatures($subEvent, subEventId);
          },
          handleErrorResponse: ($element, data, error) => {
            plugin.handleErrorResponse(error);
          },
          unloadRegistrationComponents: ($element, data, showSpinner) => {
            plugin.unloadRegistrationComponents(showSpinner);
          },
        },
      });

      // create instance of access codes plugin
      components.accessCodes.plugin = components.accessCodes.form.accessCodesPlugin({
        i18n: settings.i18n,
        accessCodeUrl: settings.accessCodeUrl,
        callbacks: {
          accessCodeValidated: () => {
            components.subEvents.plugin.subEventsPlugin('reloadRegistrantSubEventSelector', true);
          },
        },
      });

      // initialize popovers loaded by ajax (skip if the shell already bound them)
      if (!$('body').data('bs.popover')) {
        $('body').popover({
          placement: 'top',
          container: 'body',
          html: true,
          selector: '[data-toggle="popover"]',
        });
      }

      initializeListeners();
    };

    // Fire up
    initialize();
  };
});
